import { render, staticRenderFns } from "./VChart1.vue?vue&type=template&id=a9540d14&"
import script from "./VChart1.vue?vue&type=script&lang=js&"
export * from "./VChart1.vue?vue&type=script&lang=js&"
import style0 from "./VChart1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports